import { overlays } from '@revenuemarket/overlays';
import { useQueryClient } from '@tanstack/react-query';

import { useTaxInvoiceMapping } from '~hooks/queries/transactions/mapping/query';
import { useDemoAwareCompanyId } from '~hooks/useDemoAwareCompanyId';

import SettlementListDrawer from './SettlementListDrawer';
import SettlementMappingModal from './SettlementMappingModal';
import { SettlementStatus } from './utils';

interface Props {
  transactionId: number;
  labelId: number;
  open: boolean;
  onClose: () => void;
}

const SettlementListDrawerWrapper: React.FC<Props> = ({
  transactionId,
  labelId,
  open,
  onClose,
}) => {
  const { companyId } = useDemoAwareCompanyId();
  const queryClient = useQueryClient();

  // 세금계산서 매핑 정보 조회
  const { data: taxInvoiceMappingData, refetch } = useTaxInvoiceMapping({
    companyId,
    transactionId,
    labelId,
  });

  const taxInvoiceMappings = taxInvoiceMappingData?.Data?.data?.items || [];

  if (taxInvoiceMappings.length === 0) {
    return null; // 매핑 정보가 없으면 아무것도 렌더링하지 않음
  }

  const firstMapping = taxInvoiceMappings[0];

  return (
    <SettlementListDrawer
      taxInvoiceId={firstMapping.id}
      type={firstMapping.type}
      status={'DONE' as SettlementStatus}
      showEditButton={false}
      onEditButtonClick={(callback) => {
        overlays.open(({ isOpen: modalOpen, onClose: modalClose }) => (
          <SettlementMappingModal
            taxInvoiceId={firstMapping.id}
            taxInvoiceType={firstMapping.type}
            targetDate={firstMapping.reportingDate || new Date().toISOString().split('T')[0]}
            onMappingSuccess={() => {
              modalClose();
              callback?.();
            }}
            onClose={modalClose}
            open={modalOpen}
            onCancel={modalClose}
          />
        ));
      }}
      open={open}
      onClose={onClose}
    />
  );
};

export default SettlementListDrawerWrapper;
